import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetGroupQuery } from '@/services/sibling-group-api';
import Page from '@/components/page';
import PageTitle from '@/components/page-title';
import AddForm from './add-form';

const AddChildPage = () => {
  const navigate = useNavigate();
  const { groupId } = useParams();
  const { data, isLoading } = useGetGroupQuery({ groupId }, { skip: !groupId });

  useEffect(() => {
    if (groupId && !isLoading && !data) {
      navigate('/sibling-group');
    }
  }, [groupId, data, isLoading, navigate]);

  return (
    <Page
      breadcrumb={[
        { path: '/sibling-group', label: 'Sibling Group' },
        groupId && { path: `/sibling-group/${groupId}`, label: groupId },
        'Add Children',
      ]}
      size="xl"
      loading={groupId && !data}
    >
      <PageTitle label="Add Children" />
      {data && <AddForm groupData={data} />}
    </Page>
  );
};

export default AddChildPage;
